import { Badge, BadgeVariant } from '@moment/design-system-ui/badge'
import { useMemo } from 'react'

export type ComplianceStatus = 'satisfied' | 'violation' | 'new'

const STATUS_CONFIG = {
  satisfied: {
    variant: BadgeVariant.Success,
    label: 'Satisfied',
  },
  violation: {
    variant: BadgeVariant.Danger,
    label: 'Violation',
  },
  new: {
    variant: BadgeVariant.Neutral,
    label: 'New',
  },
} as const

interface ComplianceStatusBadgeProps {
  status: ComplianceStatus
  className?: string
}

export function ComplianceStatusBadge({
  status,
  className,
}: ComplianceStatusBadgeProps) {
  const { variant, label } = useMemo(() => STATUS_CONFIG[status], [status])

  return (
    <Badge variant={variant} className={className}>
      {label}
    </Badge>
  )
}
